import React, { useState } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
import { 
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress,
  Divider,
  Avatar,
  Grid,
  Link
} from '@mui/material';
import {
  CreditCard as CreditCardIcon,
  Lock as LockIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

// const stripePromise = loadStripe('your-publishable-key-here');

const CheckoutPage = () => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');

    const handleCheckout = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const response = await fetch('/api/payment/create-checkout-session', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    productName: 'Premium Subscription', 
                    amount: 1000,
                    customerEmail: email 
                }),
            });

            const session = await response.json();
            // const stripe = await stripePromise;

            // const { error } = await stripe.redirectToCheckout({ 
            //     sessionId: session.id 
            // });
            
            // if (error) throw error;
        } catch (error) {
            console.error("Payment error:", error);
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56 }}>
                        <CreditCardIcon fontSize="large" />
                    </Avatar>
                </Box>
                
                <Typography variant="h4" align="center" gutterBottom>
                    Complete Your Purchase
                </Typography>
                <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
                    Premium Subscription - $10.00
                </Typography>
                
                <Box component="form" onSubmit={handleCheckout} sx={{ mt: 3 }}>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Email address"
                        type="email"
                        variant="outlined"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    
                    <Divider sx={{ my: 3 }} />
                    
                    <Button
                        fullWidth
                        type="submit"
                        color='primary'
                        variant="contained"
                        size="large"
                        disabled={loading || !email}
                        endIcon={loading ? null : <ArrowForwardIcon />}
                        sx={{ py: 1.5 }}
                    >
                        {loading ? (
                            <>
                                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                                Processing...
                            </>
                        ) : 'Pay $10.00'}
                    </Button>
                    
                    <Grid container alignItems="center" justifyContent="center" spacing={1} sx={{ mt: 2 }}>
                        <Grid item>
                            <LockIcon color="action" fontSize="small" />
                        </Grid>
                        <Grid item>
                            <Typography variant="caption" color="text.secondary">
                                Secure payment with Stripe
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Container>
    );
};

export default CheckoutPage;